import { useState } from 'react'
import { roundOffAndFormatNumberWithCurrency } from '../../../utils/utils'
import InPlaceNameValueAccordion from '../../ui-components/InPlaceNameValueAccordion'
import NameValueTable from '../../ui-components/NameValueTable'
import type { TaxLiabilityData } from './utils'
import { TaxCategories } from '../../../types/mutual-fund-detail.types'

type LTCGProps = {
  taxLiabilityData: TaxLiabilityData
}

export const LTCG = ({ taxLiabilityData }: LTCGProps) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const taxCategory = taxLiabilityData?.taxCategory

  const getLTCGValueText = () => {
    if ([TaxCategories.HYBRID_NON_EQUITY, TaxCategories.NON_EQUITY].includes(taxCategory as TaxCategories)) {
      return `Investment held for 2Y or more`
    }
    if (
      [TaxCategories.EQUITY, TaxCategories.HYBRID_EQUITY, TaxCategories.ELSS].includes(taxCategory as TaxCategories)
    ) {
      return `Investment held for 1Y or more`
    }
    if ([TaxCategories.DEBT, TaxCategories.HYBRID_DEBT].includes(taxCategory as TaxCategories)) {
      return `Investments made before 1 Apr ‘23`
    }
    return 'Investment held for 1Y or more'
  }

  return (
    <div
      style={{
        width: isExpanded ? 'calc(100% + 24px)' : '100%',
        marginLeft: isExpanded ? '-12px' : '0px'
      }}
      className={`w-full ${isExpanded ? 'pb-3' : 'pb-4'}`}
    >
      <InPlaceNameValueAccordion
        name={`LTCG Tax @ ${taxLiabilityData?.ltcgTaxInfo?.taxRate}%`}
        value={`${roundOffAndFormatNumberWithCurrency(taxLiabilityData?.ltcgTaxInfo?.taxableAmount)}`}
        nameClassName='!text-[#095EB2] !font-[500] !text-[13px]'
        valueClassName='!text-[#095EB2] !text-[13px]'
        chevronColor='#095EB2'
        accordionClassName={isExpanded ? '!bg-[#E6F2FF]' : ''}
        isExpanded={isExpanded}
        alwaysShowValue={true}
        onAccordionClick={() => setIsExpanded((isExpandedPrev) => !isExpandedPrev)}
      >
        <div className='flex flex-col w-full'>
          <NameValueTable
            data={[
              {
                name: `${getLTCGValueText()}`,
                value: `${roundOffAndFormatNumberWithCurrency(taxLiabilityData?.ltcgTaxInfo?.investedAmount)}`
              },
              {
                name: 'Long term capital gains',
                value: `${taxLiabilityData?.ltcgTaxInfo?.gains < 0 ? '-' : ''}${roundOffAndFormatNumberWithCurrency(Math.abs(taxLiabilityData?.ltcgTaxInfo?.gains ?? 0))}`
              }
            ]}
            nameClassName='!text-[#3D3D3D] !text-[13px]'
            valueClassName='!text-[13px]'
            gap={4}
          />
          {taxLiabilityData?.grandfatheringRuleApplicable && (
            <>
              <hr className='mt-2 border-[#3D3D3D] opacity-10' />
              <div className='text-[#6A6E6E] font-[400] text-[13px] pt-2'>
                Above gains may be lower due to updated tax rules (Section 112A).
              </div>
            </>
          )}
        </div>
      </InPlaceNameValueAccordion>
    </div>
  )
}
